import styled from 'styled-components';

export const ActionsContainer = styled.div`
  display: flex;
`;

export const FieldList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldRow = styled.div`
  display: flex;
  gap: 6px;
  align-items: center;
`;

export const FieldLabel = styled.div`
  font-weight: 600;
  margin-top: 12px;
  margin-bottom: 4px;
`;

export const ErrorText = styled.div`
  color: ${p => p.theme.colours?.red ?? '#d4380d'};
  font-size: 12px;
  margin-top: 4px;
`;
